import { IXC_FUNDING_V1_SOURCE_STATE_ENTITY_NAME } from '@interxfi/api-client/generated/entities/ixc-funding-v1-source-state';
import { Pill, type PillProps } from '@interxfi/design-system/components/pill/pill';
import { TranslatedText } from '@interxfi/translation/components/translated-text';
import type { IxcFundingV1SourceStatus } from '@interxfi/types/generated/api';
import { getEntityVariant } from '../../../util/entity-status-variants';

interface FundingSourceStatusPillProps extends Omit<PillProps, 'children' | 'variant'> {
  status: IxcFundingV1SourceStatus | undefined;
}

export function FundingSourceStatusPill({ isPending, status, ...props }: FundingSourceStatusPillProps) {
  return (
    <Pill isPending={!status || isPending} {...props} variant={getEntityVariant(IXC_FUNDING_V1_SOURCE_STATE_ENTITY_NAME, status)}>
      <TranslatedText defaultValue={status} i18nKey={{ namespace: 'ixcFundingV1', enumName: 'IxcFundingV1SourceStatus', value: status }} />
    </Pill>
  );
}
